import { FaDraftingCompass, FaHardHat, FaPencilRuler } from 'react-icons/fa';
import { v4 as uuidv4 } from 'uuid';
import thumb1 from '../../assets/img/approch1.jpg';
import thumb2 from '../../assets/img/approch2.jpg';
import thumb3 from '../../assets/img/approch3.jpg';

const approchData = [
    {
        id: uuidv4(),
        thumb: thumb1,
        icon: <FaDraftingCompass />,
        heading: 'Our Vision',
        text: 'To be Australia\'s leading partner in transforming innovative concepts into precision-engineered reality through cutting-edge rapid prototyping, advanced manufacturing solutions, and excellence in engineering design.',
    },

    {
        id: uuidv4(),
        thumb: thumb2,
        icon: <FaPencilRuler />,
        heading: 'Our Mission',
        text: 'Empowering Australian businesses with world-class CAD design, 3D scanning, and manufacturing consulting services that deliver exceptional quality, efficiency, and ISO-compliant solutions.',
    },

    {
        id: uuidv4(),
        thumb: thumb3,
        icon: <FaHardHat />,
        heading: 'Our Approach',
        text: 'We combine advanced technology with deep engineering expertise to provide comprehensive, client-focused solutions from initial design through to production optimisation and quality assurance.',
    },
];

export default approchData;
